import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from '@emotion/react';
import { Icon } from '../../display/Icon/Icon.es.js';
import { TooltipWrapper } from '../../display/TooltipWrapper/TooltipWrapper.es.js';
import { BaseButton } from '../Button/BaseButton.es.js';

function BaseIconButton(_a) {
  var { icon, isCircle, label, shouldCorrectTooltipPosition, tooltipId, tooltipPosition } = _a, buttonProps = __rest(_a, ["icon", "isCircle", "label", "shouldCorrectTooltipPosition", "tooltipId", "tooltipPosition"]);
  return jsx(TooltipWrapper, { content: label, position: tooltipPosition, shouldCorrectPosition: shouldCorrectTooltipPosition, showTooltipOnTouchDevices: false, tooltipId }, ({ childProps }) => jsx(
    BaseButton,
    Object.assign({ "aria-label": label }, buttonProps, childProps, { isPill: isCircle, isSquare: true }),
    jsx(Icon, { canAcceptPointerEvents: false, isBlock: true, name: icon })
  ));
}

export { BaseIconButton };
//# sourceMappingURL=BaseIconButton.es.js.map
